import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import * as userReducers from './user'
import * as alertasReducers from './alertas';
import * as cameraReducers from './cameras';
import * as routeReducers from './route';
import * as buscaCamerasReducers from './buscaCameras';
import * as geolocationReducers from './geolocation';
import * as timelineReducers from './cameraTimeline';

const rootReducer = combineReducers({
  ...cameraReducers,
  ...userReducers,
  ...alertasReducers,
  ...buscaCamerasReducers,
  ...geolocationReducers,
  ...routeReducers,
  ...timelineReducers,

  form: formReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js